<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path id="nmxhbqmiza" d="M0-.002h15.988V14H0z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path
        d="M7.994 9.75a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1M7.994 12.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
        fill="#E88A03"
      />
      <g transform="translate(0 1)">
        <mask id="shsqkxqp1b" fill="#fff">
          <use xlink:href="#nmxhbqmiza" />
        </mask>
        <path
          d="M7.994-.002c-.96 0-1.92.482-2.452 1.447l-5.29 9.589C-.484 12.367.48 14 2.002 14h11.983c1.523 0 2.487-1.633 1.75-2.966l-5.29-9.589A2.77 2.77 0 0 0 7.994-.002m0 2c.176 0 .502.054.7.414l5.086 9.217a.25.25 0 0 1-.22.371H2.428a.25.25 0 0 1-.22-.371l5.086-9.217a.774.774 0 0 1 .7-.414"
          fill="#E88A03"
          mask="url(#shsqkxqp1b)"
        />
      </g>
    </g>
  </svg>
</template>
